var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67708 13.1534H4.34263C2.8633 13.1534 1.66406 12.132 1.66406 10.6345C1.66406 9.137 2.8633 7.92301 4.34263 7.92301C4.44323 7.92301 4.54253 7.92863 4.64025 7.93957V7.92301H4.67709C4.65278 7.72562 4.64025 7.52452 4.64025 7.32046C4.64025 4.65819 6.77223 2.5 9.40216 2.5C11.1831 2.5 12.7356 3.48966 13.5525 4.95535C13.7521 4.92562 13.9563 4.91023 14.1641 4.91023C16.4653 4.91023 18.3307 6.79865 18.3307 9.12813C18.3307 11.253 16.7785 12.8183 14.7593 13.1107H12.6016M9.69978 8.22429V17.5M9.69978 17.5L7.58854 15.4173M9.69978 17.5L11.7552 15.4173",
    stroke: "#314064",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6ac5edfcd5c88d0348dbd1c40c7c5352.svg";
export { ForwardRef as ReactComponent };